/* VOLTDESK: site widgets — exit-intent, cookie banner, recently viewed, tabs */
(function () {
  'use strict';

  /* ---------- Cookie consent banner ---------- */
  function initCookie() {
    var el = document.querySelector('[data-mt-cookie]');
    if (!el) return;
    if (localStorage.getItem('mt_cookie_choice')) { el.remove(); return; }
    el.hidden = false;
    el.querySelectorAll('[data-mt-cookie-accept]').forEach(function (b) {
      b.addEventListener('click', function () {
        localStorage.setItem('mt_cookie_choice', b.getAttribute('data-mt-cookie-accept'));
        el.classList.add('mt-cookie--out');
        setTimeout(function () { el.remove(); }, 350);
      });
    });
  }

  /* ---------- Exit-intent popup (desktop only) ---------- */
  function initExitIntent() {
    var el = document.querySelector('[data-mt-exit]');
    if (!el) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;         // no en móvil
    if (sessionStorage.getItem('mt_exit_shown')) return;

    function open() {
      if (sessionStorage.getItem('mt_exit_shown')) return;
      sessionStorage.setItem('mt_exit_shown', '1');
      el.hidden = false;
      requestAnimationFrame(function () { el.classList.add('is-open'); });
      document.removeEventListener('mouseout', onOut);
    }
    function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    }
    function close() {
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; }, 300);
    }
    // arma tras 4s para no dispararse en la carga
    setTimeout(function () { document.addEventListener('mouseout', onOut); }, 4000);
    el.querySelectorAll('[data-mt-exit-close]').forEach(function (b) { b.addEventListener('click', close); });
    el.addEventListener('click', function (e) { if (e.target === el) close(); });

    var copyBtn = el.querySelector('[data-mt-exit-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code');
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        copyBtn.textContent = 'Copied ✓';
        setTimeout(function () { copyBtn.textContent = code + ' · Copy'; }, 1800);
      });
    }
  }

  /* ---------- Recently viewed ---------- */
  function readRV() { try { return JSON.parse(localStorage.getItem('mt_recently_viewed') || '[]'); } catch (e) { return []; } }
  function recordRV() {
    var meta = document.querySelector('[data-mt-rv-record]');
    if (!meta) return;
    var item = {
      handle: meta.getAttribute('data-handle'),
      title: meta.getAttribute('data-title'),
      price: meta.getAttribute('data-price'),
      image: meta.getAttribute('data-image'),
      url: meta.getAttribute('data-url')
    };
    if (!item.handle) return;
    var list = readRV().filter(function (p) { return p.handle !== item.handle; });
    list.unshift(item);
    list = list.slice(0, 8);
    localStorage.setItem('mt_recently_viewed', JSON.stringify(list));
  }
  function renderRV() {
    var wrap = document.querySelector('[data-mt-rv-list]');
    if (!wrap) return;
    var current = wrap.getAttribute('data-current');
    var list = readRV().filter(function (p) { return p.handle !== current; }).slice(0, 4);
    if (!list.length) return;
    wrap.innerHTML = list.map(function (p) {
      return '<a class="mt-rv-card mt-card" href="' + p.url + '">' +
        (p.image ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy" width="300" height="300">' : '') +
        '<div class="mt-rv-info"><p class="mt-rv-title">' + (p.title || '') + '</p>' +
        '<p class="mt-rv-price">' + (p.price || '') + '</p></div></a>';
    }).join('');
    var section = wrap.closest('[data-mt-rv-section]');
    if (section) section.hidden = false;
  }

  /* ---------- Product tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-mt-tabs]').forEach(function (tabs) {
      var btns = tabs.querySelectorAll('[data-mt-tab]');
      var panels = tabs.querySelectorAll('[data-mt-panel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-mt-tab');
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-mt-panel') !== id; });
        });
      });
    });
  }

  function init() {
    initCookie();
    initExitIntent();
    recordRV();
    renderRV();
    initTabs();
  }
  // Guard: el archivo se incluye una vez por sección; init debe correr solo una vez.
  if (window.__mtWidgetsBooted) return;
  window.__mtWidgetsBooted = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
